import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'validacao-documento',
  },
  {
    path: 'validacao-documento',
    loadComponent: () =>
      import('./features/document-validation/pages/validation-home/validation-home').then(
        (m) => m.ValidationHome,
      ),
  },
  {
    path: 'validacao-documento/interno',
    loadComponent: () =>
      import('./features/document-validation/pages/validation-home/validation-home').then(
        (m) => m.ValidationHome,
      ),
    data: { embedded: true },
  },
  {
    path: 'validacao-documento/interno/:codigo',
    loadComponent: () =>
      import('./features/document-validation/pages/validation-home/validation-home').then(
        (m) => m.ValidationHome,
      ),
    data: { embedded: true },
  },
  {
    path: 'validacao-documento/:codigo',
    loadComponent: () =>
      import('./features/document-validation/pages/validation-home/validation-home').then(
        (m) => m.ValidationHome,
      ),
  },
  {
    path: '**',
    redirectTo: 'validacao-documento',
  },
];
